// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// This replaces sentry.client.config.ts for Turbopack compatibility.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
// https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"140531b487b0fc3281f344120fc281c8300d4a8e"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/candidates/:token\",\"regex\":\"^/candidates/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/files\",\"regex\":\"^/candidates/([^/]+)/files$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/general-info\",\"regex\":\"^/candidates/([^/]+)/general-info$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/my-data\",\"regex\":\"^/candidates/([^/]+)/my-data$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/otp\",\"regex\":\"^/candidates/([^/]+)/otp$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/profile\",\"regex\":\"^/candidates/([^/]+)/profile$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/signin\",\"regex\":\"^/candidates/([^/]+)/signin$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidates/:token/thanks\",\"regex\":\"^/candidates/([^/]+)/thanks$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token\",\"regex\":\"^/candidatesAI/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/additional-info\",\"regex\":\"^/candidatesAI/([^/]+)/additional-info$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/availability\",\"regex\":\"^/candidatesAI/([^/]+)/availability$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/cv-intake\",\"regex\":\"^/candidatesAI/([^/]+)/cv-intake$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/education\",\"regex\":\"^/candidatesAI/([^/]+)/education$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/experience\",\"regex\":\"^/candidatesAI/([^/]+)/experience$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/files\",\"regex\":\"^/candidatesAI/([^/]+)/files$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/general-info\",\"regex\":\"^/candidatesAI/([^/]+)/general-info$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/my-data\",\"regex\":\"^/candidatesAI/([^/]+)/my-data$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/otp\",\"regex\":\"^/candidatesAI/([^/]+)/otp$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/signin\",\"regex\":\"^/candidatesAI/([^/]+)/signin$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/candidatesAI/:token/thanks\",\"regex\":\"^/candidatesAI/([^/]+)/thanks$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:token\",\"regex\":\"^/customers/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/info/:token\",\"regex\":\"^/info/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/services/:token\",\"regex\":\"^/services/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/subscription/invoice/:id\",\"regex\":\"^/subscription/invoice/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/view/budget/:token\",\"regex\":\"^/view/budget/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/view/budget/:token/v2\",\"regex\":\"^/view/budget/([^/]+)/v2$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/reports/:contractId\",\"regex\":\"^/reports/([^/]+)$\",\"paramNames\":[\"contractId\"],\"hasOptionalPrefix\":false},{\"path\":\"/budget-stats/:id\",\"regex\":\"^/budget-stats/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/info/invalid\"},{\"path\":\"/invalid\"},{\"path\":\"/reports\"},{\"path\":\"/reports/login\"},{\"path\":\"/reports/terms\"},{\"path\":\"/confirm-invitation\"},{\"path\":\"/bank\"},{\"path\":\"/budget\"},{\"path\":\"/budgets\"},{\"path\":\"/clients-patients\"},{\"path\":\"/dashboard\"},{\"path\":\"/invoices\"},{\"path\":\"/payments\"},{\"path\":\"/people\"},{\"path\":\"/scheduling\"},{\"path\":\"/scheduling-legacy\"},{\"path\":\"/service-scopes\"},{\"path\":\"/settings/account/billing\"},{\"path\":\"/settings/account/budget-crm\"},{\"path\":\"/settings/account/candidate-documents\"},{\"path\":\"/settings/account/customization\"},{\"path\":\"/settings/account/general\"},{\"path\":\"/settings/account/google-drive\"},{\"path\":\"/settings/account/holidays\"},{\"path\":\"/settings/account/locations\"},{\"path\":\"/settings/account/logs\"},{\"path\":\"/settings/account/messages\"},{\"path\":\"/settings/account/mobile-app\"},{\"path\":\"/settings/account/mobile-app/forms\"},{\"path\":\"/settings/account/otp-requests\"},{\"path\":\"/settings/account/privacy\"},{\"path\":\"/settings/account/rate-adjustments\"},{\"path\":\"/settings/account/subscription\"},{\"path\":\"/settings/account/team\"},{\"path\":\"/settings/account/usage-requests\"},{\"path\":\"/settings/demo\"},{\"path\":\"/settings/user/profile\"},{\"path\":\"/settings/user/security\"},{\"path\":\"/units\"},{\"path\":\"/forgot-password\"},{\"path\":\"/reset-password\"},{\"path\":\"/signin\"},{\"path\":\"/signup\"},{\"path\":\"/create-company\"},{\"path\":\"/invitations\"},{\"path\":\"/\"},{\"path\":\"/coming-soon\"},{\"path\":\"/cookies\"},{\"path\":\"/dpa\"},{\"path\":\"/pricing\"},{\"path\":\"/priority-club\"},{\"path\":\"/privacy\"},{\"path\":\"/privacy/request\"},{\"path\":\"/terms\"},{\"path\":\"/thank-you\"},{\"path\":\"/error\"},{\"path\":\"/mobile\"},{\"path\":\"/mobile/absences\"},{\"path\":\"/mobile/activity\"},{\"path\":\"/mobile/activity/activity-plan\"},{\"path\":\"/mobile/activity/activity-plan/detail\"},{\"path\":\"/mobile/activity/activity-plan/edit\"},{\"path\":\"/mobile/activity/day\"},{\"path\":\"/mobile/activity/detail\"},{\"path\":\"/mobile/activity/medications\"},{\"path\":\"/mobile/activity/new\"},{\"path\":\"/mobile/activity/plan\"},{\"path\":\"/mobile/activity/plan/detail\"},{\"path\":\"/mobile/activity/plan/edit\"},{\"path\":\"/mobile/activity/records\"},{\"path\":\"/mobile/agenda\"},{\"path\":\"/mobile/agenda/changes\"},{\"path\":\"/mobile/agenda/client\"},{\"path\":\"/mobile/agenda/shift\"},{\"path\":\"/mobile/attendance\"},{\"path\":\"/mobile/notifications\"},{\"path\":\"/mobile/payments\"},{\"path\":\"/mobile/payments/cycle\"},{\"path\":\"/mobile/profile\"},{\"path\":\"/mobile/profile/my-data\"},{\"path\":\"/mobile/login\"}],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs";
import { scrubPii } from "@/lib/sentry/scrub-pii";

// Only initialize Sentry in production
const isProduction = process.env.NODE_ENV === "production";

// CRITICAL: Keep this order EXACTLY the same as in next.config.mjs
// This ensures source maps uploaded during build match error events at runtime
// Priority order (must match next.config.mjs):
// 1. NEXT_PUBLIC_SENTRY_RELEASE (set by next.config.mjs env)
// 2. SENTRY_RELEASE (set by next.config.mjs env)
// 3. NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA (from Vercel)
// 4. VERCEL_GIT_COMMIT_SHA (from Vercel)
// 5. undefined (will cause source map mismatch if not set)
const release =
  (process.env.NEXT_PUBLIC_SENTRY_RELEASE as string) ||
  (process.env.SENTRY_RELEASE as string) ||
  (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA as string) ||
  (process.env.VERCEL_GIT_COMMIT_SHA as string) ||
  undefined;

// CRITICAL: Keep this order EXACTLY the same as in next.config.mjs
// Priority order (must match next.config.mjs):
// 1. NEXT_PUBLIC_BUILD_ID (set by next.config.mjs env)
// 2. SENTRY_DIST (set by next.config.mjs env)
// 3. NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA (from Vercel)
// 4. VERCEL_GIT_COMMIT_SHA (from Vercel)
// 5. undefined (will cause source map mismatch if not set)
const dist =
  (process.env.NEXT_PUBLIC_BUILD_ID as string) ||
  (process.env.SENTRY_DIST as string) ||
  (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA as string) ||
  (process.env.VERCEL_GIT_COMMIT_SHA as string) ||
  undefined;

// Log release/dist values for debugging (only in production, and only once)
if (isProduction && typeof window !== "undefined") {
  const debugInfo = {
    release,
    dist,
    NEXT_PUBLIC_SENTRY_RELEASE: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    SENTRY_RELEASE: process.env.SENTRY_RELEASE,
    NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    VERCEL_GIT_COMMIT_SHA: process.env.VERCEL_GIT_COMMIT_SHA,
    NEXT_PUBLIC_BUILD_ID: process.env.NEXT_PUBLIC_BUILD_ID,
    SENTRY_DIST: process.env.SENTRY_DIST,
  };
  console.log("[Sentry Client] Initializing with:", debugInfo);
  
  if (!release || !dist) {
    console.error(
      "[Sentry Client] ❌ WARNING: release or dist is undefined! Source maps may not match."
    );
  }
}

// Paths whose replays show their text (see the privacy note in the replay options).
const UNMASKED_TEXT_PATHS = ["/candidatesAI", "/candidates/"];
// Decided once, when the page loads: the replay options are fixed at init.
const showsTextInReplay =
  typeof window !== "undefined" &&
  UNMASKED_TEXT_PATHS.some((path) => window.location.pathname.startsWith(path));

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN || "https://3241761ce64a13019e961cb565071453@o4505030430359552.ingest.us.sentry.io/4508059628273664",
  
  // Only enable Sentry in production
  // The demo build (npm run demo:build) never reports to the real Sentry project.
  enabled: isProduction && process.env.NEXT_PUBLIC_DEMO_BUILD !== "true",
  
  // Set environment explicitly to "production" (not "vercel-production")
  environment: isProduction ? "production" : "development",
  // Make release/dist explicit to ensure artifact matching
  // CRITICAL: These must match exactly what was used during build time in next.config.mjs
  release,
  dist,

  // Global errors raised outside our code: no first-party frames, and the text
  // exists neither in the app nor in Next (browser extensions, throttled timers).
  ignoreErrors: [/callback `timer callback` was terminated/],

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      // Privacy: pages hold national IDs, health and criminal-record data, so
      // replays never show text, input values or media (docs/privacy/privacy-audit.md).
      // TEMPORARY exception: the candidate portal shows its text, to debug its upload and
      // save failures. Input values and media stay masked there. To mask it again, empty
      // UNMASKED_TEXT_PATHS; the `data-sentry-unmask` marks on the portal's buttons and
      // fixed texts then keep those readable. Never put that attribute on an element that
      // holds an input, a name, a file name or any value the user typed.
      maskAllText: !showsTextInReplay,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.1,

  // Improve diagnostics
  attachStacktrace: true,
  maxBreadcrumbs: 200,
  normalizeDepth: 6,

  // No background session recording; replays are only kept when an error occurs.
  replaysSessionSampleRate: 0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Improve source map resolution for better error tracking
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb;
  },

  // Add context and ensure source maps are properly resolved
  beforeSend(event) {
    // Ensure source maps are used for stack traces
    if (event.exception) {
      // Force Sentry to resolve source maps
      event.exception.values?.forEach((exception) => {
        if (exception.stacktrace) {
          exception.stacktrace.frames?.forEach((frame) => {
            // Ensure source map resolution
            if (frame.filename && !frame.filename.startsWith("http")) {
              // Normalize filename for source map resolution
              frame.filename = frame.filename.replace(/^webpack:\/\//, "");
            }
          });
        }
      });
    }
    // Don't send events in development
    if (!isProduction) {
      return null;
    }

    // Always send exceptions/errors, even if they're marked as warning
    // Only filter out non-exception info/warning logs (breadcrumbs, etc.)
    if (event.exception || event.level === 'error' || event.level === 'fatal') {
      // Ensure exceptions are always sent, even if level is warning
      if (event.exception) {
        event.level = 'error'; // Force error level for exceptions
      }
      
      // Add more context to errors
      event.extra = {
        ...event.extra,
        url: typeof window !== 'undefined' ? window.location.href : '',
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        timestamp: new Date().toISOString(),
        sentryClientConfig: 'client',
      };
      
      // Log for debugging (only in production console)
      if (typeof window !== 'undefined' && window.console) {
        console.log('[Sentry] Capturing error:', {
          message: event.exception?.values?.[0]?.value || event.message,
          level: event.level,
          tags: event.tags,
        });
      }
      
      return scrubPii(event);
    }

    // Filter out non-exception info/warning logs
    if (event.level === 'info' || event.level === 'warning') {
      return null;
    }
    
    return scrubPii(event);
  },
});

// Add runtime tags for better grouping/diagnostics
try {
  Sentry.setTag("runtime", "browser");
  if (typeof window !== "undefined") {
    Sentry.setTag("ua", navigator.userAgent);
  }
  if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA) {
    Sentry.setTag("commit", process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA);
  }
  if (process.env.NEXT_PUBLIC_BUILD_ID) {
    Sentry.setTag("buildId", process.env.NEXT_PUBLIC_BUILD_ID);
  }
} catch {}

// Export required hook for router transition instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

